import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { SignOnService } from 'src/app/shared/services/sign-on/sign-on.service';
import { FormatNumberService } from 'src/app/shared/utils/format-number.service';
import { RISK_LEVELS } from '../../../shared/constants/rate.constants';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { ChannelCommunicatorService, } from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { BioCatchService } from '../../../shared/services/external/biocatch/biocatch.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { ProductLoaderService } from '../../../shared/services/product-loader/product-loader.service';
import { RequestService } from '../../../shared/services/request/request-onboarding.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { callbackAdjustCA, callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { OFFERS_STATUS_CONST } from 'src/app/shared/constants/offers-status.constants';
import { DaliService } from '@dali/tagger-ng8';
import { PAGEVIEW as PAGEVIEW_FA_LD, CHANNEL as CHANNEL_FA_LD, COUNTRY as COUNTRY_FA_LD, BUSINNESS as BUSINNESS_FA_LD, ENVIRONMENT as ENVIRONMENT_FA_LD, FAMILY as FAMILY_FA_LD, SUBFAMILY as SUBFAMILY_FA_LD, PRODUCT as PRODUCT_FA_LD, } from 'src/app/shared/constants/dali-fa-ld.constants';
import { EVENT as EVENT_FA_LD } from 'src/app/shared/constants/dali-fa-ld.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
var AccountInfoCreationComponent = /** @class */ (function () {
    function AccountInfoCreationComponent(headerService, copyService, abreCuentasService, numberHelper, navigationService, productLoaderService, bioCatchService, signOnService, parametersService, bitacoraService, requestService, loader, validationHelperService, helperService, channelCommunicatorService, postValidate, captureService, firmlyApprovedService, identificationService, adjustEvent, daliService, taggingService) {
        this.headerService = headerService;
        this.copyService = copyService;
        this.abreCuentasService = abreCuentasService;
        this.numberHelper = numberHelper;
        this.navigationService = navigationService;
        this.productLoaderService = productLoaderService;
        this.bioCatchService = bioCatchService;
        this.signOnService = signOnService;
        this.parametersService = parametersService;
        this.bitacoraService = bitacoraService;
        this.requestService = requestService;
        this.loader = loader;
        this.validationHelperService = validationHelperService;
        this.helperService = helperService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.postValidate = postValidate;
        this.captureService = captureService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.identificationService = identificationService;
        this.adjustEvent = adjustEvent;
        this.daliService = daliService;
        this.taggingService = taggingService;
        this.acceptTerms = false;
        this.showRate = false;
        this.RISK_LEVELS = RISK_LEVELS;
        this.continueClick = new EventEmitter();
        this.callLink = new EventEmitter();
        this.modalShow = false;
        this.headerService.show(true, true, true);
    }
    AccountInfoCreationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sendTagging('init');
        if (this.taggingService.isFirmlyAprovedMono()) {
            this.sendAccountInfoCreationLoad();
        }
        this.firmlyApproved = !this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme';
        this.disbursment = this.abreCuentasService.getDisbursementInfo();
        console.log('Metodo Desembolso: ', this.disbursment);
        this.abreCuentasService.getDocumentInfo();
        this.formGroup = new FormGroup({
            check_terms: new FormControl('', [Validators.required]),
        });
        var product = this.abreCuentasService.getproductSelected().product_code;
        var isEvidente = this.bioCatchService.isEvidenteCase();
        this.bioCatchService.changeContext(StepBiocatchEnum.vinculacion, product, false, isEvidente);
        if (!this.firmlyApproved) {
            this.pco = this.abreCuentasService.getPcoModel().solicitation_status.status_code;
            console.log('AAAaaProducto:' + this.pco);
        }
        else {
            this.requestService.setRates(this.abreCuentasService.getAbreCuentasModel().creditParms.rateValue);
        }
        this.product = this.abreCuentasService.getproductSelected().code;
        this.productClient = this.abreCuentasService.getClientProduct();
        console.log('AAAaaClient:' + this.productClient);
        this.selectedAccount = this.abreCuentasService.getcreateProductSelected();
        this.transaction = this.parametersService.getSetting(OpEnum.TRANSACTION_KIT);
        this.infoInferredIncomes = this.abreCuentasService.getinfoInferredIncomes();
        this.userId = this.abreCuentasService.getDocumentInfo();
        this.solicitationId = this.abreCuentasService.getSolicitationId();
        switch (this.product) {
            case '209':
                this.revolvingBenefits = this.parametersService.getSetting(OpEnum.REVOLVING_BENEFITS);
                if (!this.selectedAccount) {
                    this.selectedAccount = this.abreCuentasService.getAssociateRevolving();
                }
                if (this.firmlyApproved) {
                    this.amountPco = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)[0].limit_amount.amount.toString();
                }
                else {
                    this.amountPco = this.pco === 'PCO03' ?
                        '' :
                        this.abreCuentasService.getAmountPcoAproved() + '';
                }
                this.amountPco = this.amountPco !== '' ? this.numberHelper.pcoFormat(this.amountPco) : '';
                this.termValue = this.copyService.copies.account_info_creation.term_value;
                if (this.productClient && this.selectedAccount && this.selectedAccount.account_id) {
                    this.accountNumber = this.validationHelperService.maskPhone(this.selectedAccount.account_id);
                }
                else {
                    this.accountNumber = '';
                }
                // this.accountNumber = this.productClient ? this.validationHelperService.maskPhone(this.selectedAccount.account_id) : '';
                break;
            case '211':
            case '231':
                var creditParams = this.abreCuentasService.getAbreCuentasModel().creditParms;
                this.amountPco = this.firmlyApproved ?
                    this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue.toString() :
                    this.pco === 'PCO03' ?
                        this.numberHelper.amountFormat(creditParams.maxAmountValue) :
                        this.abreCuentasService.getAmountPcoAproved() + '';
                console.log('Valor a formatear: ', this.amountPco);
                this.amountPco = this.numberHelper.pcoFormat(this.amountPco);
                this.maxPeriodTerm = creditParams.maxPeriodValue;
                this.termValue = this.maxPeriodTerm + " meses";
                this.accountNumber = this.productClient ? this.validationHelperService.maskPhone(this.selectedAccount.account_id) : '';
                console.log('Rates: ', this.requestService.getRates());
                var rates = this.requestService.getRates();
                this.rateLiving = this.firmlyApproved ?
                    rates.rate_MV + "% M.V  (" + rates.rate_EA + "% E.A)" :
                    rates[0].value + "% " + rates[0].type + "  (" + rates[1].value + "% " + rates[1].type + ")";
                this.getRates();
                break;
            case '999':
                this.check = this.abreCuentasService.getOutlaySelection() === 'cheque';
                var incomes = this.abreCuentasService.getFinancialInfo();
                var creditParamsLib = this.abreCuentasService.getAbreCuentasModel().creditParms;
                this.amountPco = this.pco === 'PCO03' ?
                    this.numberHelper.amountFormat(creditParamsLib.maxAmountValue) :
                    this.abreCuentasService.getAmountPcoAproved() + '';
                this.amountPco = this.numberHelper.pcoFormat(this.amountPco);
                this.maxPeriodTerm = creditParamsLib.maxPeriodValue;
                this.termValue = this.maxPeriodTerm + " meses";
                if (this.disbursment && this.disbursment[0]) {
                    var refund = this.disbursment[0].refund;
                    if (refund && refund[0] && refund[0].refund_method !== 'CH') {
                        this.accountNumber = refund[0].account ? this.validationHelperService.maskPhone(refund[0].account.account_id) : '';
                    }
                }
                else {
                    this.accountNumber = this.productClient ? this.validationHelperService.maskPhone(this.selectedAccount.account_id) : '';
                }
                this.showCharacteristics = incomes.incomes <= 7999000 ? false : true;
                this.showRate = true;
                this.rateLib = this.abreCuentasService.getRatesLoan();
                break;
            case '232':
                var creditParamLib = this.abreCuentasService.getAbreCuentasModel().creditParms;
                this.amountPco = this.pco === 'PCO03' ?
                    this.numberHelper.amountFormat(creditParamLib.maxAmountValue) :
                    this.abreCuentasService.getAmountPcoAproved() + '';
                this.amountPco = this.numberHelper.pcoFormat(this.amountPco);
                this.maxPeriodTerm = creditParamLib.maxPeriodValue;
                this.termValue = this.maxPeriodTerm + " meses";
                if (this.disbursment && this.disbursment[0]) {
                    var refund = this.disbursment[0].refund;
                    if (refund && refund[0] && refund[0].refund_method !== 'CH') {
                        this.accountNumber = refund[0].account ? this.validationHelperService.maskPhone(refund[0].account.account_id) : '';
                    }
                }
                else {
                    this.accountNumber = this.productClient ? this.validationHelperService.maskPhone(this.selectedAccount.account_id) : '';
                }
                this.showRate = true;
                this.rateLib = this.abreCuentasService.getRatesLoan();
                break;
            default:
                break;
        }
        /* if (this.abreCuentasService.getProspectResponse().client &&
          (this.abreCuentasService.getCustomerData().basic.sub_segment_id === '335' ||
            this.abreCuentasService.getCustomerData().basic.sub_segment_id === '315')) {
          this.infoInferredIncomes.segment_id =
            parseInt(this.abreCuentasService.getCustomerData().basic.sub_segment_id, 10);
        } */
        this.transactionkit = this.transaction.filter(function (transaction) {
            return (transaction.account_type === _this.infoInferredIncomes.account_type &&
                transaction.segmentation_id === _this.infoInferredIncomes.segment_id);
        });
        this.transactionkit = this.transactionkit[0];
        var listTermsConditions = this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS);
        this.termsConditions = listTermsConditions[2];
        this.terms = {
            description: this.termsConditions.description,
            title: this.termsConditions.code,
            terms_id: this.termsConditions.id,
        };
    };
    AccountInfoCreationComponent.prototype.monthly = function (months) {
        return months + " " + this.copyService.copies.account_info_creation.monthly;
    };
    AccountInfoCreationComponent.prototype.getRates = function () {
        this.taxRates = this.requestService.getRates();
        this.showRate = true;
    };
    AccountInfoCreationComponent.prototype.checkTerms = function (event) {
        this.acceptTerms = event.checked;
    };
    AccountInfoCreationComponent.prototype.showModalEvent = function (event) {
        switch (event.type) {
            case 'primary':
                this.downloadPdf();
                break;
            case 'click':
                this.modalShow = true;
                break;
            case 'close':
                this.modalShow = false;
                break;
            default:
                break;
        }
    };
    /**
     * Method to download pdf
     */
    AccountInfoCreationComponent.prototype.downloadPdf = function () {
        this.channelCommunicatorService.getImpl().openPdf(this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS)[0].pdfUrl);
    };
    /*   openLink() {
        this.callLink.emit();
      } */
    AccountInfoCreationComponent.prototype.checkBioCatch = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sendTagging('next', 'center', '2');
                        if (this.taggingService.isFirmlyAprovedMono()) {
                            this.sendRequestButtonEvent();
                        }
                        return [4 /*yield*/, this.bioCatchService.update()];
                    case 1:
                        _a.sent();
                        this.bioCatchService.checkScore(false).then(function (response) {
                            if (response.data.response) {
                                _this.next();
                                return;
                            }
                            _this.navigationService.navigateToGeneralInformation('122');
                            _this.navigationService.pageLoadTag('Error carga vinculacion', ['', 'pv132', 'pv93']);
                            var productSelected = _this.abreCuentasService.getproductSelected();
                            if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS) {
                                var event_1 = {
                                    eventToken: 'n2wxne',
                                    callbackParams: callbackAdjustCA,
                                };
                                _this.adjustEvent.adjustTrackEvent(event_1);
                            }
                            else if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
                                var event_2 = {
                                    eventToken: '6hsnuc',
                                    callbackParams: callbackAdjustContratarTC,
                                };
                                _this.adjustEvent.adjustTrackEvent(event_2);
                            }
                        }, function () {
                            _this.navigationService.navigateToGeneralInformation('500');
                        }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountInfoCreationComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var product_name, gray_zone, bitacoraEvent, productType, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loader.show('Alta_Productos_zn');
                        product_name = this.abreCuentasService.getproductSelected().product_code;
                        if (this.abreCuentasService.haveLoan) {
                            this.productLoaderService.show(this.copyService.copies.show_load_pco, this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['ALTA']);
                        }
                        gray_zone = this.pco === 'PCO03' ? 'zg_' : '';
                        this.grayZone = this.pco === 'PCO03' ? true : false;
                        bitacoraEvent = '';
                        if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
                            productType = {
                                ORD: 'cp',
                                TCR: 'tc',
                                CRP: 'cr',
                                default: '',
                            };
                            this.bitacoraService.saveDataInBitacora("offer_approvedf_" + product_name);
                            bitacoraEvent = "af_accepted_multi_" + (productType[product_name] ? productType[product_name] : productType.default);
                        }
                        else {
                            bitacoraEvent = "product_accepted_" + gray_zone + product_name;
                        }
                        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                        // Relacionados
                        return [4 /*yield*/, this.checkRelated()];
                    case 1:
                        // Relacionados
                        _a.sent();
                        if (!this.continueRelated) {
                            this.productLoaderService.hide();
                            return [2 /*return*/];
                        }
                        this.signOnService.termsAndConditions();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 6, , 7]);
                        return [4 /*yield*/, this.postValidate.performSolicitation()];
                    case 3:
                        _a.sent();
                        this.bitacoraService.saveDataInBitacora('Ini_loading_Product');
                        return [4 /*yield*/, this.callerSleep()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.captureService.getChannelComunicator(true).then(function (res2) {
                                if (CHANNEL.PORTALO.CODE === _this.abreCuentasService.chanelid && _this.abreCuentasService.getflagGreyZone()) {
                                    _this.loader.hide('Alta_Productos_zn');
                                    _this.navigationService.navigateToGeneralInformation('137');
                                    return;
                                }
                                else if (!_this.grayZone && (_this.abreCuentasService.getproductSelected().product_type === 'freeInvestment' ||
                                    _this.abreCuentasService.getproductSelected().product_type === 'revolvingCredit' ||
                                    _this.abreCuentasService.getproductSelected().product_type === 'loan')) {
                                    if (!_this.firmlyApprovedService.isEmpty()) {
                                        var product_list = [];
                                        product_list.push(_this.abreCuentasService.getproductSelected());
                                        _this.firmlyApprovedService.turnOffOffer(OFFERS_STATUS_CONST.PRODUCT_ACCEPTED.CODE, product_list);
                                    }
                                    _this.bitacoraService.saveDataInBitacora('Out_loading_Product');
                                    _this.loader.hide('Alta_Productos_zn');
                                    _this.navigationService.navigateToGeneralInformation('138');
                                    return;
                                }
                                else {
                                    (res2 === '107' || res2 === '121' || res2 === '130' || res2 === '129' || res2 === '124' || res2 === '125' || res2 === '127') ?
                                        _this.navigationService.navigateToGeneralInformation(res2) :
                                        _this.navigationService.nextStep(res2);
                                }
                                if (res2 === '208') {
                                    _this.bitacoraService.saveDataInBitacora('Possible_fraud_Yes');
                                }
                                else if (res2 === '20-04') {
                                    res2 = '208';
                                    _this.bitacoraService.saveDataInBitacora('Possible_fraud_incident');
                                }
                                var productSelected = _this.abreCuentasService.getproductSelected();
                                if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC && res2 === '121') {
                                    var event_3 = {
                                        eventToken: 'huswfn',
                                        callbackParams: callbackAdjustContratarTC,
                                    };
                                    _this.adjustEvent.adjustTrackEvent(event_3);
                                }
                                _this.bitacoraService.saveDataInBitacora('Out_loading_Product');
                                _this.loader.hide('Alta_Productos_zn');
                                _this.productLoaderService.hide();
                            }).catch(function () { return _this.navigationService.navigateToGeneralInformation('107'); })];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        this.loader.hide('Alta_Productos_zn');
                        console.log(error_1);
                        this.navigationService.navigateToGeneralInformation('107');
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    AccountInfoCreationComponent.prototype.callerSleep = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.abreCuentasService.haveLoan) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['ALTA'])];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.BONDING_ASYNC)['sleep'])];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        _a;
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountInfoCreationComponent.prototype.checkRelated = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var document, resInfo, bitacoraEvent, pcoStatus;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.continueRelated = true;
                        document = this.abreCuentasService.getDocumentInfo().document_number;
                        return [4 /*yield*/, this.identificationService.validateIfIsRelated(document)];
                    case 1:
                        resInfo = _a.sent();
                        console.log(resInfo);
                        if (!resInfo.related) {
                            return [2 /*return*/];
                        }
                        bitacoraEvent = "employee_members";
                        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                        pcoStatus = this.abreCuentasService.getPcoModel().solicitation_status.status_code;
                        // PCO Aprobado continúa a "Tu solicitud fue recibida y la estamos validando"
                        if (pcoStatus !== 'PCO01') {
                            return [2 /*return*/];
                        }
                        this.navigationService.nextStep('202');
                        this.productLoaderService.hide();
                        this.continueRelated = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountInfoCreationComponent.prototype.goToLink = function () {
        this.channelCommunicatorService.getImpl()
            .openExternalBrowser('https://www.itau.co/tasasytarifas', 5, this.abreCuentasService.getPostlogin());
    };
    /* ------------------ Taggeo ------------------ */
    /* ------------ Taggeo - PageLoad ------------ */
    AccountInfoCreationComponent.prototype.sendAccountInfoCreationLoad = function () {
        var isApp = this.channelCommunicatorService.getChannelId() === '141';
        var changes = [
            {
                path: PAGEVIEW_FA_LD.pv14pageName.path,
                value: (isApp ? CHANNEL_FA_LD.superapp : CHANNEL_FA_LD.homeBanking) + ":" + COUNTRY_FA_LD.co + ":" + BUSINNESS_FA_LD.pf + ":" + ENVIRONMENT_FA_LD.loggeado + ":" + FAMILY_FA_LD.services + ":" + SUBFAMILY_FA_LD.request + ":" + PRODUCT_FA_LD.request + ":" + PAGEVIEW_FA_LD.pv14pageName.value,
            },
            {
                path: PAGEVIEW_FA_LD.pv14pageFamily.path,
                value: PAGEVIEW_FA_LD.pv14pageFamily.value,
            },
            {
                path: PAGEVIEW_FA_LD.pv14subFamily.path,
                value: PAGEVIEW_FA_LD.pv14subFamily.value,
            },
            {
                path: PAGEVIEW_FA_LD.pv14pageAction.path,
                value: PAGEVIEW_FA_LD.pv14pageAction.value,
            },
            {
                path: PAGEVIEW_FA_LD.pv14pageid.path,
                value: AccountInfoCreationComponent.name,
            },
            {
                path: PAGEVIEW_FA_LD.pv14transactionName.path,
                value: "" + PAGEVIEW_FA_LD.pv14transactionName.value.slice(0, -2) + this.taggingService.getProductFlow(),
            },
            {
                path: PAGEVIEW_FA_LD.pv14transactionTransactionStep.path,
                value: PAGEVIEW_FA_LD.pv14transactionTransactionStep.value,
            },
        ];
        this.taggingService.addCommonPageChanges(changes);
        this.daliService.pageLoad(changes);
    };
    /* -------------- Taggeo - Events ------------- */
    AccountInfoCreationComponent.prototype.sendBackButtonEvent = function () {
        this.sendTagging('prev', 'center', '1');
        if (!this.taggingService.isFirmlyAprovedMono()) {
            return;
        }
        var data = [
            {
                path: EVENT_FA_LD.pv14E1setData.pv14E1transactionTransactionStep.path,
                value: EVENT_FA_LD.pv14E1setData.pv14E1transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_LD.pv14E1setData.pv14E1transactionName.path,
                value: "" + EVENT_FA_LD.pv14E1setData.pv14E1transactionName.value.slice(0, -2) + this.taggingService.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_LD.customCategory.module.body,
                type: EVENT_FA_LD.customCategory.type.button,
                position: EVENT_FA_LD.customCategory.position.center,
            },
            action: EVENT_FA_LD.customAction.click,
            label: EVENT_FA_LD.pv14E1customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    AccountInfoCreationComponent.prototype.sendRequestButtonEvent = function () {
        if (!this.taggingService.isFirmlyAprovedMono()) {
            return;
        }
        var data = [
            {
                path: EVENT_FA_LD.pv14E2setData.pv14E2transactionTransactionStep.path,
                value: EVENT_FA_LD.pv14E2setData.pv14E2transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_LD.pv14E2setData.pv14E2transactionName.path,
                value: "" + EVENT_FA_LD.pv14E2setData.pv14E2transactionName.value.slice(0, -2) + this.taggingService.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_LD.customCategory.module.body,
                type: EVENT_FA_LD.customCategory.type.button,
                position: EVENT_FA_LD.customCategory.position.center,
            },
            action: EVENT_FA_LD.customAction.click,
            label: EVENT_FA_LD.pv14E2customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    AccountInfoCreationComponent.prototype.sendTagging = function (value, position, event) {
        var grayZone = this.abreCuentasService.isGrayZone();
        var page = grayZone ? '21' : '20';
        var extras = {
            pageValue: 'AccountInfoCreation' + (grayZone ? 'GrayZone' : ''),
        };
        this.taggingService.sendTaggValues(value, page, position, event, extras);
    };
    return AccountInfoCreationComponent;
}());
export { AccountInfoCreationComponent };
